export default __webpack_public_path__ + "static/media/ecommerce-tablet-side.5cf22a99.webp";